<template>
    <el-dialog title="审核" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true"
        width="512px">
        <div class="info-box" v-if="detailData.collection_type === 1">
            <p>银行账户名称: {{ detailData.withdrawal_log.bank_name }}</p>
            <p>支店名: {{ detailData.withdrawal_log.branch_name }}</p>
            <p>预金类目: {{ detailData.withdrawal_log.type === 1 ? '普通' : '当座' }}</p>
            <p>口座番号: {{ detailData.withdrawal_log.kouzuo_no }}</p>
            <p>口座名称: {{ detailData.withdrawal_log.kouzuo_name }}</p>
        </div>
        <div class="info-box" v-else-if="detailData.collection_type === 2">
            <p>支付宝昵称: {{ detailData.withdrawal_log.name }}</p>
            <p>支付宝账号: {{ detailData.withdrawal_log.account }}</p>
        </div>
        <div class="info-box" v-else-if="detailData.collection_type === 3">
            <p>Paypay昵称: {{ detailData.withdrawal_log.name }}</p>
            <p>Paypay ID: {{ detailData.withdrawal_log.accountId }}</p>
            <p>手机号: {{ detailData.withdrawal_log.phone }}</p>
        </div>
        <div class="options-box">
            <el-button @click="trunOff">返回</el-button>
            <template v-if="detailData.state === 0">
                <el-button type="warning" @click="rejectModalVisible = true">驳回</el-button>
                <el-button type="primary" @click="handlePass('通过')">通过</el-button>
            </template>
            <el-button v-else-if="detailData.state === 1" type="primary" @click="handleOver()">已打款</el-button>
        </div>

        <el-dialog title="驳回" :visible.sync="rejectModalVisible" :close-on-click-modal="false" :destroy-on-close="true"
            append-to-body width="512px">
            <el-form ref="rejectForm" :model="rejectForm" :rules="rejectRules" label-width="0px">
                <el-form-item prop="reason">
                    <el-input type="textarea" placeholder="驳回理由" :rows="4" v-model="rejectForm.reason"></el-input>
                </el-form-item>
                <el-row type="flex" justify="end">
                    <el-button @click="rejectModalVisible = false">取消</el-button>
                    <el-button type="primary" @click="submitForm('rejectForm')">确认</el-button>
                </el-row>
            </el-form>
        </el-dialog>
    </el-dialog>
</template>

<script>
import { payoutRequests } from "@/api/payoutManagement"

export default {
    data: () => ({
        rejectRules: {
            reason: [
                { required: true, message: '请填写驳回理由', trigger: 'blur' }
            ]
        },
        rejectForm: {
            reason: ''
        },
        rejectModalVisible: false
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        detailData: null | Object
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        handlePass(text) {
            this.$confirm("此操作将" + text + "该提现申请, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                try {
                    await payoutRequests.approve(this.detailData.id)
                    this.$message({
                        message: '已通过该申请!',
                        type: 'success'
                    });
                    this.$emit("onUpdate")
                    this.trunOff()
                } catch {
                    this.$message.error('操作失败!');
                }
            })
        },
        handleOver() {
            this.$confirm("将确认已打款, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(async () => {
                try {
                    await payoutRequests.paid(this.detailData.id)
                    this.$message({
                        message: '已确认已打款!',
                        type: 'success'
                    });
                    this.$emit("onUpdate")
                    this.trunOff()
                } catch {
                    this.$message.error('操作失败!');
                }
            })
        },
        // 提交
        async submitForm(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        await payoutRequests.reject({ reason: this.rejectForm.reason, id: this.detailData.id })
                        this.$message({
                            message: "已驳回该申请!",
                            type: 'success'
                        });
                        this.rejectModalVisible = false
                        this.$emit("onUpdate")
                        this.trunOff()
                    } catch {
                        this.$message.error('出错了!');
                    }
                }
            });
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        }
    },
    watch: {
        show(v) {
            if (v) {
                this.rejectForm.reason = ''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.info-box {
    margin-top: -14px;
}
</style>
